export default (fieldName, required, prefillValue) => ({
    fieldName,
    required,
    hasSpouse: false,
    prefillValue,
    person: {},
    children: [],
    personTemplate: {
        gender: '',
        birthday: '',
        /* eslint-disable camelcase */
        tobacco_use: '',
    },
    formatBirthdayPrefillValue(value) {

        if (typeof value !== 'string') {
            return value
        }

        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            return value
        }

        const [ year, month, day ] = value.split('-')

        return `${ month }/${ day }/${ year }`

    },

    formatPersonPrefillValue(person) {

        if (!person || typeof person !== 'object') {
            return person
        }

        return {
            ...person,
            birthday: this.formatBirthdayPrefillValue(person.birthday),
        }

    },

    formatChildrenPrefillValue(children) {

        if (Array.isArray(children)) {
            return children.map(child => this.formatPersonPrefillValue(child))
        }

        if (!children || typeof children !== 'object') {
            return children
        }

        const normalizedChildren = {}

        for (const child in children) {
            normalizedChildren[ child ] = this.formatPersonPrefillValue(children[ child ])
        }

        return normalizedChildren

    },

    formatPrefillValue(prefillValue) {

        if (!prefillValue || typeof prefillValue !== 'object') {
            return prefillValue
        }

        return {
            ...prefillValue,
            spouse: this.formatPersonPrefillValue(prefillValue.spouse),
            children: this.formatChildrenPrefillValue(prefillValue.children),
        }

    },

    addSpouse() {

        this.hasSpouse = true
        this.person = { ...this.personTemplate }

    },

    addChild() {
        this.children.push({ ...this.personTemplate })
    },

    removePerson(type, index = 0) {

        if (type === 'spouse') {

            this.hasSpouse = false
            this.person = {}

        } else {
            this.children.splice(index, 1)
        }

    },

    setValue() {

        this.$store.webForm.component.setFormData(this.fieldName, {
            spouse: this.person,
            children: this.children,
            children_count: this.children.length,
        })

    },

    async validateAndSetSpouse() {

        this.setValue()

        for (const key in this.personTemplate) {

            if (!this.person[ key ]) {
                return false
            }

        }

        if (this.person.birthday.length === 10) {
            this.$store.webForm.state.canSubmit = true
        }

    },

    async validateAndSetChild() {

        this.setValue()

        const isValid = this.children.every(child => {

            for (const key in this.personTemplate) {

                if (!child[ key ]) {
                    return false
                }

            }

            if (child.birthday.length === 10) {
                return true
            }

            return false

        })

        if (isValid) {
            this.$store.webForm.state.canSubmit = true
        }

    },
    init() {

        const prefillValue = this.formatPrefillValue(this.prefillValue)

        if (prefillValue) {

            const spouse = prefillValue.spouse
            const children = prefillValue.children

            if (spouse) {

                this.hasSpouse = true
                this.person = { ...this.personTemplate }

            }

            if (children) {

                /* eslint-disable @typescript-eslint/no-unused-vars */
                for (const child in children) {
                    this.children.push({ ...this.personTemplate })
                }

            }

            this.$nextTick(() => {

                // Set the real values
                this.person = { ...spouse }
                this.children = children
                this.setValue()

            })

        }

        this.$watch('person', () => this.validateAndSetSpouse(), { deep: true })
        this.$watch('children', () => this.validateAndSetChild(), { deep: true })

    },
})
